var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbtack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M15.363 14.014l1.885-4.21 1.42.82a.934.934 0 001.274-.341l.933-1.613a.928.928 0 00-.341-1.27L11.38 2.124a.932.932 0 00-1.273.34l-.933 1.613a.93.93 0 00.341 1.271l1.42.818-2.709 3.735c-2.07-.183-4.116.449-5.102 2.153a.93.93 0 00.341 1.271l4.577 2.638-2.021 3.493a.308.308 0 00-.041.136l-.125 2.078a.311.311 0 00.482.277l1.74-1.147a.322.322 0 00.098-.103l2.02-3.493 4.576 2.637a.934.934 0 001.274-.341c.96-1.66.53-3.663-.564-5.312l-.12-.175z"
  }))));
}

export default SvgThumbtack;